module.exports = __webpack_public_path__ + "static/media/not.4a9f6843.png";